import { isFunction } from 'lodash'
import * as React from 'react'
import Spinner from '@src/components/common/loader'
import {
  getFeatureFlags,
  RegistredFeatureflag
} from '@src/endpoints/feature.flag'
import type { State } from '../models'
import { setPending } from '../helpers'

export interface Props<T> {
  pending?: boolean
  flags: RegistredFeatureflag[]
  component?: React.ComponentType<State['flags']> | React.ReactNode
  children?: ((props: State['flags']) => React.ReactNode) | React.ReactNode
  deps?: ReadonlyArray<any>
  ownProps?: T
}

function WaitFeatureFlags<T>(props: React.PropsWithChildren<Props<T>>) {
  const { children, flags, component, deps = [], pending, ownProps } = props
  const [featureFlagsData, setData] = React.useState<State>({
    flags: {},
    pending
  })

  function fetch() {
    setData(prev => setPending(prev, true))
    getFeatureFlags(flags, {
      signal: null
    }).then(fFlags => {
      setData(prev => ({
        ...setPending(
          {
            ...prev,
            flags: { ...prev?.flags, ...fFlags }
          },
          false
        )
      }))
    })
  }

  React.useEffect(() => {
    fetch()
  }, deps)

  function renderBody() {
    return component
      ? React.createElement(component as any, {
          ...featureFlagsData?.flags,
          ...ownProps
        })
      : children
      ? isFunction(children)
        ? (children as (props: State['flags']) => React.ReactNode)({
            ...featureFlagsData?.flags,
            ...ownProps
          })
        : children
      : null
  }

  return (
    <>
      {!featureFlagsData?.pending ? (
        renderBody()
      ) : (
        <Spinner loading={featureFlagsData?.pending} />
      )}
    </>
  )
}

WaitFeatureFlags.defaultProps = {
  deps: [],
  pending: true
}

export default React.memo(WaitFeatureFlags)
